import {Component, Input} from '@angular/core';
import {ActivityInfo} from '@webmate-web-core/shared/services/audit.service';
import {
    MiniHorizontalStackChartComponent,
    MiniHorizontalStackChartItem
} from './mini-horizontal-stack-chart.component';

/**
 * Renders the activity breakdown of an {@link ActivityInfo} as a {@link MiniHorizontalStackChartComponent},
 * or a "No activities" placeholder when there are no evaluated activities. Centralizes the chart-item
 * preprocessing that would otherwise be duplicated at every call site.
 */
@Component({
    selector: 'wm-activity-info-chart',
    templateUrl: './activity-info-chart.component.html',
    styleUrls: ['./activity-info-chart.component.less'],
    standalone: true,
    imports: [
        MiniHorizontalStackChartComponent
    ]
})
export class ActivityInfoChartComponent {
    @Input() activityInfo!: ActivityInfo;

    get hasActivities(): boolean {
        return this.total > 0;
    }

    get chartItems(): MiniHorizontalStackChartItem[] {
        if (!this.activityInfo || this.total <= 0) {
            return [];
        }
        const info = this.activityInfo;
        return [
            {
                label: 'Failed',
                color: 'var(--wm-error-bg)',
                textColor: 'var(--wm-error-text-contrast)',
                value: info.numFailed
            },
            {
                label: 'Passed',
                color: 'var(--wm-success-bg)',
                textColor: 'var(--wm-success-text-contrast)',
                value: info.numPassed
            },
            {
                label: 'Not Applicable',
                color: '#FFFF00',
                value: info.numNotApplicable
            },
            {
                label: 'Undecided',
                color: 'transparent',
                value: info.numUndecided
            }
        ];
    }

    private get total(): number {
        const info = this.activityInfo;
        if (!info) {
            return 0;
        }
        return info.numFailed + info.numPassed + info.numUndecided + info.numNotApplicable;
    }
}
